export default (key, extraClass = '', extraAttributes = '') => `
  <svg class='icon icon-${key} ${extraClass}' aria-hidden='true' ${extraAttributes}>
    <use xlink:href='#icon-${key}'></use>
  </svg>
`;
